export default function ({$config, store}) {
  if (!store.getters['languages/current']) {
    store.commit('languages/setCurrentLanguage', $config.defaultLocale)
  }
}
